import CpHome from "@/components/communityPortal/home/CpHome";
import NotFound from "@/components/common/NotFound";
import { isCommunityPortal } from "@/utils/type";
import { fetchGraphqlCommunityPortal } from "@/utils/query";
import { processMdx } from "@/utils/mdx";

function HomePage({ type, companyMarkdownCode }) {
    return isCommunityPortal(type) ? (
        <CpHome companyMarkdownCode={companyMarkdownCode} />
    ) : (
        <NotFound />
    );
}

// export async function getStaticProps() {
//     return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
// }

export async function getServerSideProps(context) {
    const { company } = context.query;

    let code = "";

    if (company) {
        // const res = await fetch(
        //     `/api/community-portal/company/getMarkdown?companyId=${company}`
        // );
        //const data = await res.json();

        //if (data && data.code) {
        //    code = data.code;
        //}

        const result = await fetchGraphqlCommunityPortal(
            `
            query($find: JSON) {
                companys(find: $find) {
                    companyMarkdown
                }
            }
        `,
            {
                find: {
                    companyId: company,
                },
            },
            "",
            "read-only"
        );

        if (
            result &&
            result.data &&
            result.data.companys &&
            result.data.companys.length > 0
        ) {
            const company = result.data.companys[0];

            let post;
            if (company.companyMarkdown) {
                post = await processMdx(
                    company.companyMarkdown
                        .replaceAll("\n", "  \n")
                        .replaceAll("<br>", "  \n")
                );
            } else {
                post = { code: "", frontMatter: {} };
            }

            code = post.code;
        }
    }

    return { props: { type: process.env.NEXT_PUBLIC_TYPE, companyMarkdownCode: code } };
}

export default HomePage;
